export const settingsOptions = [
  { key: 'my_profile', isDisabled: false },
  { key: 'personal_information', isDisabled: false },
  { key: 'sponsor_and_enroller', isDisabled: false },
  { key: 'communications', isDisabled: false, externalUrl: "https://info.unicity.com/Preference-Center_LP.html" },
  { key: 'security', isDisabled: false, externalUrl: "https://office.unicity.com/pwupdate/#/reset" },
  { key: 'upload_kyc', isDisabled: false, externalUrl: "https://india.unicityportal.com/warehouseorder/kycpage/create?ba_id={unicityId}" },
  { key: 'language', isDisabled: true },
  { key: 'placement_program', isDisabled: false }
]